import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  methods,
  mounted,

  mixins: [crud],

  resourcePath: 'v1/professional/schedules/statistics/status'
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/statistics/resources/index.js